import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import moment from 'moment-timezone';
import RaisedButton from 'material-ui/RaisedButton';
import { OrderActions, UserActions, FleetActions, ManifestActions } from '../../../actions';
import { ManifestService } from '../../../services';
import Loader from '../../../components/Loader';
import TitleBar from '../../../components/TitleBar';
import SubnavBar from '../../../components/SubnavBar';
import ManifestForm from '../../../components/Dispatcher/Manifests/Edit';

class EditManifest extends Component {

  constructor(props) {
    super(props);

    this.saveManifest = this.saveManifest.bind(this);
  }

  componentWillMount() {
    const { dispatch, drivers, units, trailers } = this.props;

    dispatch(OrderActions.getOnDoc());
    if (!drivers) {
      dispatch(UserActions.getDrivers());
    }
    if (!units) {
      dispatch(FleetActions.getUnits());
    }
    if (!trailers) {
      dispatch(FleetActions.getTrailers());
    }
  }

  saveManifest(values) {
    const { auth, dispatch, drivers, units, trailers } = this.props;
    const { stops } = values;
    const driver = _.find(drivers.list, item => item.name === values.driver);
    const unit = _.find(units.list, item => item.name === values.unit);
    const trailer = _.find(trailers.list, item => item.name === values.trailer);

    const obj = {
      deliveryDate: moment.tz(values.deliveryDate, 'America/Chicago').format("YYYY-MM-DD"),
      driverId: driver.id,
      truckId: unit.id,
      trailerId: trailer.id
    }

    const processStops = (s) => {
      return _.map(s, (value, key) => ({
        locationId: key,
        trackingNumbers: _.map(value, (item) => item.props.value)
      }));
    }

    const p = processStops(stops);

    
    ManifestService.create(auth, obj).then((response) => {
      return ManifestService.addStops(auth, response.id, p);
    }).then((response) => {
      dispatch(ManifestActions.getAll());
      browserHistory.push('/dispatcher/manifests');
    });
  }

  gotoManifests = () => {
    browserHistory.push('/dispatcher/manifests');
  }


  render() {
    const { orders, drivers, units, trailers } = this.props;
    let content = <Loader />;

    if (!orders || orders.fetching || !drivers || drivers.fetching || !units || units.fetching || !trailers || trailers.fetching) {
      content = <Loader />;
    } else if (orders.onDoc.length === 0) {
      content = (
        <div>
        <div className="row">
          <div className="col s12">No orders at facility.  Scan orders in to create a new manifest.</div>
        </div>
        <div className="row">
          <div className="col s12"><RaisedButton onClick={this.gotoManifests} label="Return to Manifests" /></div>
        </div></div>);
    } else {
      content = (<div>
          <ManifestForm onSubmit={this.saveManifest} orders={orders.onDoc} drivers={drivers.list} units={units.list} trailers={trailers.list} />
        </div>);
    }
    

    return (
      <div>
        <div className="row">
          <div className="col s12">
            <SubnavBar back={this.gotoManifests} />
            <TitleBar title="Create a Manifest" />
            <div className="row">
              <div className="col s12">
                {content}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { auth, orders, drivers, fleet } = state;
  return {
    auth: auth.auth,
    orders,
    drivers,
    units: (fleet) ? fleet.units : null,
    trailers: (fleet) ? fleet.trailers : null
  };
}

export default connect(mapStateToProps)(EditManifest);


// WEBPACK FOOTER //
// ./src/containers/Dispatcher/Manifests/Edit.js